const recurringInput = {
  repeatEvery: 'Alle wiederholen',
  repeatOn: 'Wiederholen am',
  ends: 'Ende',
  endsOn: 'Endet am',

  form: {
    month: 'Monat',
    day: 'Tag',
    week: 'Woche',
    year: 'Jahr',
    occurrences: 'Vorkommen',
    after: 'Nach',
    never: 'Niemals',
    on: 'An',
  },
};

export default recurringInput;
